
import { useState } from 'react';
import { Youtube, Instagram, PlayCircle, TrendingUp, ArrowRight } from 'lucide-react';
import HeroSection from '@/components/ui-custom/HeroSection';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import SocialMediaFeeds from '@/components/media/SocialMediaFeeds';
import FeaturedContent from '@/components/media/FeaturedContent';
import LogBook from '@/components/media/LogBook';

const Media = () => {
  const [activeVideoTab, setActiveVideoTab] = useState('recent');

  const renderYoutubeSubscribe = () => {
    return;
    return (
      <section>
        <div className="glass rounded-xl p-8 md:p-12 text-center">
          <div className="mb-2">
            <Youtube size={32} className="text-red-600 mx-auto" />
          </div>
          <h3 className="heading-lg text-white mb-4">Subscribe to Our Channel</h3>
          <p className="text-adv-lightGray max-w-2xl mx-auto mb-8">
            Never miss a video or update. Subscribe to our YouTube channel for the latest adventure motorcycle content.
          </p>
          <a 
            href="https://youtube.com/@Exodusadv" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-primary bg-red-600 hover:bg-red-700 inline-flex items-center"
          >
            <Youtube size={18} className="mr-2" /> Subscribe on YouTube
          </a>
        </div>
      </section>
    );
  }

  const renderLogBook = () => {
    return <LogBook />;
  }

  return (
    <div className="bg-adv-dark min-h-screen">
      <HeroSection
        title="Content Garage"
        subtitle="Videos, ride reports, and adventure inspiration"
        backgroundImage="/images/media-hero.jpg"
      />
      
      <main id="content" className="py-16 md:py-20">
        <div className="container-custom">
          {/* ExodusADV Social Feeds Section */}
          <section className="mb-16 md:mb-24">
            <SocialMediaFeeds />
          </section>
          
          {/* Featured Content Section */}
          <section className="mb-16 md:mb-24">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-8">
              <div>
                <h2 className="heading-lg text-white mb-2">Featured Content</h2>
                <p className="text-adv-lightGray max-w-2xl">
                  Curated videos and stories from the broader ADV community
                </p>
              </div>
            </div>
            
            <FeaturedContent />
          </section>
          
          {renderYoutubeSubscribe()}
          {renderLogBook()}
        </div>
      </main>
    </div>
  );
};

export default Media;
